import { Select, type SelectOption } from './primitives/select';

export type FilterSelectOption = SelectOption;

export type FilterSelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<FilterSelectOption>;
  className?: string;
  label?: string;
  'aria-label'?: string;
  disabled?: boolean;
  error?: boolean;
};

export function FilterSelect({
  value,
  onChange,
  options,
  className = '',
  label,
  'aria-label': ariaLabel,
  disabled = false,
  error = false,
}: FilterSelectProps) {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      className={className}
      label={label}
      aria-label={ariaLabel}
      disabled={disabled}
      error={error}
    />
  );
}
